export default __webpack_public_path__ + "static/media/bars.896a3d23.svg";